import React from 'react';
import styles from './FieldWrapper.module.css';

/**
 * FieldWrapper - Atom component for consistent field layout
 * Provides margin and full-width styling for form fields
 *
 * @param {React.ReactNode} children - Field content to wrap
 * @param {string} className - Additional CSS class names
 * @param {Object} style - Inline styles (e.g., for columnWidth)
 */
const FieldWrapper = ({ children, className = '', style = {} }) => {
  return (
    <div className={`${styles.fieldWrapper} ${className}`.trim()} style={style}>
      {children}
    </div>
  );
};

export default FieldWrapper;
